import React from 'react';
import styles from './RaidFvBootLoader.module.css';

export default function RaidFvBootLoader({
  exiting = false,
  progress = 0,
  onExited,
}) {
  const clampedProgress = Math.max(0, Math.min(1, progress));
  const percent = Math.round(clampedProgress * 100);

  return (
    <div
      className={`${styles.overlay} ${exiting ? styles.exiting : ''}`}
      onTransitionEnd={event => {
        // 退場フェード（opacity）の完了時のみ親へ通知する。
        if (event.propertyName !== 'opacity' || !exiting) {
          return;
        }

        onExited?.();
      }}
    >
      <div
        className={styles.panel}
        role="progressbar"
        aria-live="polite"
        aria-busy={!exiting}
        aria-valuemin={0}
        aria-valuemax={100}
        aria-valuenow={percent}
        aria-label="ページを読み込み中"
      >
        <p className={styles.label}>Loading {percent}%</p>
        <div className={styles.track}>
          <div
            className={styles.fill}
            style={{ width: `${Math.max(clampedProgress * 100, 2)}%` }}
          />
        </div>
      </div>
    </div>
  );
}
